import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import type {
  ProductsFilters,
  Pagination,
} from '@app/pages/Warehouses/Products/types';

import type { MenuProps } from 'antd';

export const PF = 'products';

export const initialFilters: ProductsFilters = {
  WarehouseId: null,
  SearchTerm: null,
  CategoryIds: [],
  BrandIds: [],
  PriceOfPurchaseS: null,
  PriceOfPurchaseE: null,
  PriceOfSaleS: null,
  PriceOfSaleE: null,
  IsAtMinimal: false,
  IsAtCritical: false,
};

export const initPagination: Pagination = {
  ItemsPerPage: 20,
  PageN: 1,
  Total: 0,
};

export const PRODUCTS_REGISTRY_STORAGE_KEY = 'ProductsRegistryFilters.v1';

export const PRODUCTS_TABLE_MENU: NonNullable<MenuProps['items']> = [
  {
    key: 'edit',
    label: 'Редактировать карточку',
    icon: <EditOutlined />,
  },
  {
    key: 'edit-sale-price',
    label: 'Изменить цену продажи',
    icon: <EditOutlined />,
  },
  {
    key: 'delete',
    label: 'Удалить',
    icon: <DeleteOutlined />,
  },
];
